import {
  assign, endpoint, options, check, convert,
} from '../helpers';
import { Report as action } from '../../redux/actions';

/**
 * Updates report
 *
 * @function
 * @param {Object} properties All parameters to be used in the function
 */

const reports = (properties) => {
  const props = assign(properties);
  const model = {
    Report: props.data.uuid,
    Data: {
      Report: props.data.report,
      Configuration: props.data.configuration.rules.map(item => ({
        Column: item.cell,
        Row: item.row,
        TableAddress: item.formula ? `$${item.formula}` : `${props.data.configuration.table}$${item.column}`,
      })),
    },
  };

  fetch(endpoint('/update-report'), options(model))
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        if (props.dispatch) {
          props.dispatch(action.update({
            Report: model.Report,
            Data: {
              Configuration: model.Data.Configuration,
              Name: model.Data.Report,
              Template: model.Data.Template,
            },
          }));
        }
        props.success(convert(response.Message));
      } else {
        props.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default reports;
